import React from 'react';
import axios from 'axios';
import { useHistory, useLocation } from 'react-router-dom';
import { useAlert } from 'react-alert';
import MetaData from '../../layouts/MetaData';
import RoleShell from '../../components/Enrollment/RoleShell';
import DeviceRequestForm from '../../components/DeviceRequests/DeviceRequestForm';
import { DR_API } from '../../components/DeviceRequests/deviceRequestApi';

const DeviceRequestNew = () => {
    const history = useHistory();
    const location = useLocation();
    const alert = useAlert();
    const presetPatientId = location?.state?.patientid || new URLSearchParams(location.search).get('patientId') || '';
    const submit = async (payload, ack) => {
        const { data } = await axios.post(DR_API, { ...payload, ...(ack ? { acknowledgeDuplicates: true } : {}) });
        alert.success(`Device request ${data.requestNo} submitted`);
        history.push(`/device-requests/${data._id || data.id}`);
    };
    return (
        <RoleShell title="New RPM Device Request">
            <MetaData title="New RPM Device Request" />
            <h5>New RPM Device Request</h5>
            <DeviceRequestForm mode="create" presetPatientId={presetPatientId} onSubmit={submit} onCancel={() => history.goBack()} />
        </RoleShell>
    );
};

export default DeviceRequestNew;
